import {Button, Dialog, DialogActions, DialogContent, Stack, Typography, useMediaQuery, useTheme} from "@mui/material";
import {Notification} from "../../utils/models/Notification";
import {useTranslation} from "react-i18next";

interface Props {
    notification: Notification;
    open: boolean;
    handleClose(): void;
}

type SupportedLocale = 'fr' | 'de' | 'it';

export default function DialogOpenNotification({notification, open, handleClose}: Props) {
    const {t, i18n} = useTranslation();
    const currentLocale = i18n.language as SupportedLocale;

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    return (
        <Dialog
            maxWidth={false}
            fullScreen={fullScreen}
            open={open}
            onClose={handleClose}
            className={"notification-dialog"}
        >
            <Typography variant={"h4"} sx={{mt: 2, ml: 2}}>
                {t("dialog_open_notification_title")}
            </Typography>
            <DialogContent sx={{mt: 2, ml:2, mr: 2, p: 0}}>
                <Typography variant={"h5"}>
                    {notification.notification.title[`${currentLocale}`]}
                </Typography>
                <Typography sx={{mb: 1}} variant={"body1"}>
                    {notification.notification.body[`${currentLocale}`]}
                </Typography>
                <Typography sx={{mt: 1, mb: 1}} variant={"body1"}>
                    {
                        t("dialog_open_notification_number_users", {
                            number_users: notification.personalReferences.length ?? '{{number_users}}'
                        })
                    }
                </Typography>
                <Typography
                    variant={"body1Bold"}>
                    {t("dialog_open_notification_users_list")}
                </Typography>
                {notification.personalReferences.length > 0 &&
                    <Stack sx={{overflowY: "scroll", height: "50vh", border: "1px solid grey"}}>
                        <pre>
                            {JSON.stringify(JSON.parse(notification.context), null, 2) }
                        </pre>
                    </Stack>
                }
            </DialogContent>
            <DialogActions>
                <Button
                    color="secondary"
                    variant="contained"
                    onClick={handleClose}>
                    {t("button_label_close")}
                </Button>
            </DialogActions>
        </Dialog>
    )
}